export default __webpack_public_path__ + "static/media/carta.baa5fa90.jpeg";